import { useTooltip as useTooltipVisx } from "@visx/tooltip";
import TooltipStoreContext from "./contexts/TooltipStoreContext";
import type { Points } from "./TooltipProvider.types";

interface TooltipProviderProps {
  children?: React.ReactNode;
}

function TooltipProvider(props: TooltipProviderProps) {
  const store = useTooltipVisx<Points<unknown>>();

  return <TooltipStoreContext.Provider value={store}>{props.children}</TooltipStoreContext.Provider>;
}

export default TooltipProvider;
